import { $api } from "../generated/client";

export const useGetCarrierInformationPerMonthQuery = ({
	shopId,
	startMonthTimeStamp,
}: {
	shopId: string;
	startMonthTimeStamp: string;
}) => {
	const query = $api.useQuery(
		"get",
		"/shops/{shopId}/analytics/carrier-information-per-month",
		{
			params: {
				path: { shopId },
				query: {
					startMonthTimeStamp,
				},
			},
		},
	);
	return query;
};
